<template>
  <div>
    <!-- title -->
    <ots-main-title :mainTopBtn="mainTopBtnList" />

    <!-- form  -->
    <ots-refer
      class="mb20"
      :selectList="selectList"
      :request-form="requestForm"
      @search="search"
    />

    <!-- table -->
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableData="tableData"
      :batchOperBtn="batchOperBtn"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>
  </div>
</template>
<script>
import {
  getSyncLogDataInfo,
  syncExamDataSet,
  getEnableSyncExamStateInfo,
} from "@/http/modules/examSet/journal";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
const timeShortCuts = [
  {
    text: "今天",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "昨天",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      picker.$emit("pick", [start, end]);
    },
  },
  {
    text: "最近一周",
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit("pick", [start, end]);
    },
  },
];
export default {
  name: "journal",
  data() {
    return {
      // 页面 title 标题
      mainTopBtnList: [],
      // 表单搜索配置
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "同步时间",
          type: "datetimerange",
          requestKey: "datetimerange_time",
          pickerOptions: {
            shortcuts: timeShortCuts,
          },
        },
        {
          title: "同步状态",
          type: "select",
          requestKey: "state",
          label: "name",
          value: "id",
          data: [
            { name: "全部", id: "" },
            { name: "成功", id: "1" },
            { name: "失败", id: "0" },
          ],
        },
      ],
      // 查询信息总数
      pagination: {
        total: 0,
      },
      // 表格数据请求参数
      requestForm: {
        datetimerange_time: [],
        planId: "",
        state: "",
        beginTime: "",
        endTime: "",
        page: 1,
        size: 10,
      },
      // 表格字段配置
      tableHeader: [
        { title: "考试批次", prop: "planName" },
        { title: "同步数据项", prop: "optItem" },
        { title: "同步时间", prop: "optTime" },
        { title: "操作人", prop: "realName" },
        { title: "操作功能", prop: "optType" },
        { title: "同步状态", prop: "state" },
        { title: "备注", prop: "reason" },
      ],
      // 表格数据
      tableData: [],
      // 表格左上方按钮
      batchOperBtn: [],
      batchOperBtnInfo: [
        {
          title: "重新同步考生",
          icon: "iconfont icon-bianji",
          click: this.syncStudents,
        },
      ],
      // 当前考试批次 id
      currentPlanId: "",
    };
  },
  watch: {
    // 同步时间监听 ( 配置开始时间, 结束时间 )
    "requestForm.datetimerange_time"(val) {
      if (val && val.length) {
        this.requestForm.beginTime = val[0];
        this.requestForm.endTime = val[1];
      } else {
        this.requestForm.beginTime = "";
        this.requestForm.endTime = "";
      }
    },
    // 监听考试批次变化, 同步查询 (val==null, 查全部)
    "requestForm.planId"() {
      // 更新日志
      this.search();
      // 是否展示表格日志按钮
      this.isUseSyncStudent();
      this.getCurrentPlan();
    },
  },

  mounted() {
    /* *** 初始化数据 *** */
    this.initData();
  },
  methods: {
    /********************************
     * @initData 表单下拉数据配置
     *******************************/
    initData() {
      // 1. 考试批次列表 ( 默认最新批次 )
      this.mixin_getSelectPlan().then((data) => {
        this.$set(this.selectList[0], "data", [
          { name: "全部", id: "" },
          ...data,
        ]);
        this.requestForm.planId = data[0].id;
        this.getCurrentPlan();
      });
    },
    getCurrentPlan() {
      // 2. 获取当前考试批次, 其它批次隐藏 (同步考生按钮);
      getCurrentPlanFn({
        planId: this.requestForm.planId,
      }).then((data) => {
        this.currentPlanId = data.id;
      });
    },

    /********************************
     * @this 点击查询重置页码
     *******************************/
    search() {
      this.requestForm.page = 1;
      this.getLogList();
    },

    /********************************
     * @getLogList 表单数据查询
     *******************************/
    getLogList() {
      // 1. 接口参数配置, 去除日期范围参数
      let params = { ...this.requestForm };
      delete params.datetimerange_time;
      // 2. 调用 查询日志 接口
      getSyncLogDataInfo(params).then((res) => {
        if (res.code == 1) {
          this.pagination.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },

    /********************************
     * @getLogList 表格按钮是否可以使用
     *******************************/
    isUseSyncStudent() {
      // 1. 判断所选批次是否是 最新批次
      if (this.currentPlanId == this.requestForm.planId) {
        // 2. (判断表格是否出现 "重新同步考生按钮")
        getEnableSyncExamStateInfo().then(({ data }) => {
          if (data == 1) {
            this.batchOperBtn = this.batchOperBtnInfo;
          } else {
            this.batchOperBtn = [];
          }
        });
      } else {
        // 2. 非 最新批次, 不显示同步按钮
        this.batchOperBtn = [];
      }
    },

    /********************************
     * @getLogList 表格按钮
     *******************************/
    syncStudents() {
      this.$confirm("确认同步当前考试批次的考生数据？", "提示", {
        type: "warning",
      })
        .then(() => {
          syncExamDataSet().then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功！");
            } else {
              this.$message.warning("同步失败！");
            }
          });
        })
        .catch(() => {});
    },

    // 分页相关
    changeSize(num) {
      this.requestForm.size = num;
      this.getLogList();
    },
    // 分页相关
    changePage(p) {
      this.requestForm.page = p;
      this.getLogList();
    },
  },
};
</script>
